<template>
  <div class="teacher-element" :class="{ 'in-work': inWork }">
    <vs-avatar
      :src="
        teacher.options && teacher.options.avatar
          ? `${proxy}/static/files/${teacher.options.avatar}`
          : undefined
      "
      :size="size"
    ></vs-avatar>
    <slot></slot>
    <div
      class="teacher-busy main-busy"
      v-if="
        teacher.busy &&
        teacher.busy.main_teacher &&
        teacher.busy.main_teacher.length
      "
    >
      <div
        class="teacher-busy__item"
        v-for="(busy, index) in teacher.busy.main_teacher"
        :key="index"
      >
        <group :color="busy.group_color" :id="busy.group_id" size="16px">{{
          busy.group_name
        }}</group>
      </div>
    </div>
    <div
      class="teacher-busy other-busy"
      v-if="
        teacher.busy &&
        teacher.busy.other_teacher &&
        teacher.busy.other_teacher.length
      "
    >
      <div
        class="teacher-busy__item"
        v-for="(busy, index) in teacher.busy.other_teacher"
        :key="index"
      >
        <group :color="busy.group_color" :id="busy.group_id" size="16px"
          >Sub: {{ busy.group_name }}</group
        >
      </div>
    </div>
    <div
      class="teacher-busy other-busy"
      v-if="
        teacher.busy && teacher.busy.assistant && teacher.busy.assistant.length
      "
    >
      <div
        class="teacher-busy__item"
        v-for="(busy, index) in teacher.busy.assistant"
        :key="index"
      >
        <group :color="busy.group_color" :id="busy.group_id" size="16px"
          >A: {{ busy.group_name }}</group
        >
      </div>
    </div>
  </div>
</template>

<script>
import Group from './group.vue'

export default {
  props: {
    teacher: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    inWork: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proxy: process.env.VUE_APP_PROXY,
    }
  },
  components: {
    Group,
  },
}
</script>

<style lang="scss">
.teacher-element {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  &.in-work {
    .con-vs-avatar {
      outline: 2px solid rgba(var(--vs-primary));
    }
  }
  .teacher-busy {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 5px;
    margin-left: 10px;
    &__item {
      padding: 2px 3px;
      border-radius: 5px;
      background-color: #eee;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
        rgba(0, 0, 0, 0.06) 0px -1px 2px 0px;
    }
  }
}
</style>
